import React from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    Modal,
    Button,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Form } from 'react-final-form';
import axios from "axios";
import {useDispatch, flashSuccess, flashError} from "@/shared/components/flash"
import FieldUserStatus from './FieldUserStatus'
import "./style.scss";

const ChangeStatusModal = ({ organization, isOpen, setOpen, toggle, theme, rtl, user, setTrigger }) => {
    const dispatch = useDispatch()

    const onSubmitChangeStatus = values => {
        // console.log(values)
        // return;
        // setLoading(true)
        axios.patch(`/organization/${organization.id}/user/${user.id}/status`, values)
        .then( (res) => {
            if(res.status == 200)  {
                dispatch({ type: 'TRIGGER_QUERY' });
                setTrigger( Math.floor(Date.now() / 1000) )
                flashSuccess(dispatch, "User Status updated successfully!")
                toggle()
            }
        })
        .catch( error => {
            console.log(error.response.data);
            flashError(dispatch, error.response.data)
        })
    }

    const validate = values => {
        return true;
    }
    
    return (
        <Modal className={`modal-action manager-program-modal modal-md ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
            <ModalHeader tag="div" className="manager-program-modal__header manager-program-action-modal__header">
                <h3 className="manager-program-action-modal__title">Change Status</h3>
                <button
                    type="button"
                    className="manager-program-action-modal__close"
                    aria-label="Close"
                    onClick={toggle}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody className="manager-program-modal__body manager-program-action-modal__body">
                <Form
                    onSubmit={onSubmitChangeStatus}
                    validate={validate}
                    initialValues={{
                        user_status_id: String(user.status.id)
                    }}
                >
                    {({ handleSubmit }) => (
                        <form className="form" onSubmit={handleSubmit}>
                            <div className="form__form-group label-mb-0 manager-program-action-modal__group">
                                <FieldUserStatus />
                            </div>
                            <div className="manager-program-action-modal__footer">
                                <Button type="button" className="manager-program-action-modal__action" onClick={toggle}>
                                    Cancel
                                </Button>
                                <Button className="manager-program-action-modal__action manager-program-action-modal__action--primary" type="submit">
                                    Submit
                                </Button>
                            </div>
                        </form>
                    )}
                </Form>
            </ModalBody>
        </Modal>
    )
}

ChangeStatusModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};

export default (connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization,
    program: state.program
}))(ChangeStatusModal));
